import Image from "next/image";
import React, { CSSProperties } from "react";

interface SummaryProps {
  id: string;
  isSummaryOpen: boolean;
  detailStyles?: CSSProperties;
  summaryStyles?: CSSProperties;
  onClose: (event: any) => void;
  children: React.ReactNode;
  labelType: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "span" | "p" | "hr";
  labelStyle?: CSSProperties;
  className: string;
  closeImageConfig: {
    src: string;
    imageHeight?: string;
    imageWidth?: string;
    alt?: string;
    className?: string;
  };
  label?: string;
}

const Summary = ({
  id,
  isSummaryOpen,
  detailStyles,
  summaryStyles,
  onClose,
  children,
  className,
  labelType,
  labelStyle,
  closeImageConfig,
  label = "",
}: SummaryProps) => {
  const LabelType = labelType;
  const imageNode = (
    <Image
      src={closeImageConfig.src}
      alt={closeImageConfig.alt ?? "Arrow"}
      width={parseFloat(closeImageConfig.imageHeight?.toString() ?? "24")}
      height={parseFloat(closeImageConfig.imageWidth?.toString() ?? "24")}
      style={{
        height: closeImageConfig.imageHeight,
        width: closeImageConfig.imageWidth,
        display: "flex",
        alignItems: "center",
      }}
      className={`accordion-toggle-image ${closeImageConfig.className}`}
      aria-label={closeImageConfig.src}
      priority={false}
      unoptimized
      fetchPriority="auto"
    />
  );
  return (
    <details
      style={detailStyles}
      className={className}
      id={id}
      open={isSummaryOpen}
    >
      <summary
        style={summaryStyles}
        onClick={(event: any) => {
          onClose(event);
        }}
      >
        {labelType ? (
          <LabelType style={labelStyle}>
            {label}
            {imageNode}
          </LabelType>
        ) : (
          <>
            {label}
            {imageNode}
          </>
        )}
      </summary>
      {children}
    </details>
  );
};

export default Summary;
